import { TFunction } from 'i18next';

import { GraphQLSupporterPaymentMethod } from '@sola/schema/dotcom/supporters/schema.generated.ts';

/**
 * Gets the translated payment method label. Typically in the format of '{{type}} ····{{lastFour}}'.
 * @param paymentMethod The payment method.
 */
export const getPaymentMethodLabel = (
  paymentMethod: GraphQLSupporterPaymentMethod,
  t: TFunction,
): string => {
  const { creditCard, ach } = paymentMethod;
  const translationKey = 'payments.methodLabels.default';
  if (creditCard) {
    return t(translationKey, {
      type: creditCard.cardType,
      lastFour: creditCard.lastFour,
    });
  }
  if (ach) {
    return t(translationKey, {
      type: t('payments.methodTypes.ach.short'),
      lastFour: ach.lastFourOfAccountNumber,
    });
  }

  return '';
};
